/**
 * Where an unpriced item gets its price: Base Prices, opened on that item.
 *
 * Base Prices (Bundles & Quotations -> Base prices) is the editor for the
 * ACTIVE DEFAULT price book. Its writer (`PUT /commercial/product-prices/{code}`
 * -> `ProductPricingService.set_price` -> `PriceBookService.set_base_entry`)
 * writes the book `resolve()` reads, chosen by flag — on DEV "Tenant Creation
 * Book" (TC_007809). So it is the one fix for every row the server marks with
 * `remedy.action === 'set_base_price'`, wherever that row is shown: Create
 * Tenant, Edit Tenant's add-ons, a refused basket.
 *
 * The link and the page agree on its shape through THIS module, so neither can
 * drift: the link is built here and the page parses it here.
 */

/** The Base Prices tab of the commercial page. */
export const BASE_PRICES_TAB = 'prices';

/** Every tab the commercial page has; anything else in the URL is ignored. */
export const COMMERCIAL_TABS = ['quotations', 'bundles', BASE_PRICES_TAB];

/** The link to Base Prices, opened on one price-book item. */
export function basePricesHref(itemCode) {
  const query = new URLSearchParams({ tab: BASE_PRICES_TAB });
  if (itemCode) query.set('price', itemCode);
  return `/commercial?${query.toString()}`;
}

/**
 * What a commercial-page URL asks for: `{ tab, item }`.
 *
 * Naming an item implies the Base Prices tab — it is the only tab that prices
 * one. An unknown tab is ignored rather than trusted (`tab: null`), so a
 * mistyped link opens the page as usual instead of on an empty panel.
 */
export function commercialTarget(search) {
  const params = search instanceof URLSearchParams ? search : new URLSearchParams(search || '');
  const item = (params.get('price') || '').trim() || null;
  const asked = params.get('tab');
  if (item) return { tab: BASE_PRICES_TAB, item };
  return { tab: COMMERCIAL_TABS.includes(asked) ? asked : null, item: null };
}
